import React from 'react';

const Faq = () => {
    return (
        <div className='mb-56'>
            <h1 className='text-center font-extrabold text-5xl mt-10' >Update Coming soon</h1>
        </div>
    );
};

export default Faq;